/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLamp = createReactComponent("outline", "lamp", "IconLamp", [["path", { "d": "M9 20h6", "key": "svg-0" }], ["path", { "d": "M12 20v-8", "key": "svg-1" }], ["path", { "d": "M5 12h14l-4 -8h-6z", "key": "svg-2" }]]);

export { IconLamp as default };
//# sourceMappingURL=IconLamp.mjs.map
